export const initMenuFunctional = (player) => {
	const section = player.el_.closest('section');
    const menu = section ? section.querySelector('.video-js > .vjs-menu') : document.querySelector('.video-js > .vjs-menu');
	const playBackMenu = player.getChild('menu').getChild('PlaybackRateMenuButton');

	playBackMenu.off('mouseenter');
	playBackMenu.off('mouseleave');

	playBackMenu.el_.querySelector('.vjs-menu-content').addEventListener('click', () => {
		playBackMenu.el_.classList.remove('vjs-hover');
		menu.classList.remove('submenu-active');
	})
	
	playBackMenu.el_.addEventListener('click', () => {
		menu.querySelector('.vjs-playback-rate').classList.add('vjs-hover');
		menu.classList.add('submenu-active');
		playBackMenu.el_.querySelector('.vjs-menu').classList.remove('vjs-hidden');
	});

	player.on("userinactive", function() {
		menu.classList.remove('active');
		menu.classList.remove('submenu-active');
	});

	player.getChild('ControlBar').addChild('button', {
		controlText: 'Settings',
		className: 'settings',
		clickHandler: function(event) {
			menu.classList.toggle('active');
		}
	});	
}